import ResourcesPage from "@Quest/Resources/Pages/ResourcesPage.vue";
import ResourceCapacitiesPage from "@Quest/Resources/Pages/ResourceCapacitiesPage.vue";
import ResourceUnitCostsPage from "@Quest/Resources/Pages/ResourceUnitCostsPage.vue";

export const routes = [
    {
        path: "/enterprise/resources/:workspaceId/:strategyId",
        component: ResourcesPage
    },
    {
        path: "/enterprise/resource-capacity/:workspaceId/:strategyId/:resourceId",
        component: ResourceCapacitiesPage
    },
    {
        path: "/enterprise/resource-unit-costs/:workspaceId/:strategyId",
        component: ResourceUnitCostsPage
    },

]
